var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2137,
    y: 4.99121,
    width: 7.57116,
    height: 13.6065,
    fill: "#FF5F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6945 11.7957C14.6917 9.14014 15.9104 6.63085 17.9994 4.99126C14.4517 2.20317 9.35707 2.60928 6.29589 5.92419C3.2347 9.2391 3.2347 14.3499 6.29589 17.6648C9.35707 20.9797 14.4517 21.3858 17.9994 18.5977C15.9111 16.9586 14.6924 14.4504 14.6945 11.7957Z",
    fill: "#EB001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.7957C31.9999 15.1085 30.1082 18.1306 27.1284 19.5783C24.1486 21.026 20.6037 20.6452 17.9993 18.5977C20.0867 16.9572 21.3055 14.4493 21.3055 11.7944C21.3055 9.13959 20.0867 6.63168 17.9993 4.99122C20.6037 2.94367 24.1486 2.56289 27.1284 4.0106C30.1082 5.45832 31.9999 8.48035 32 11.7932V11.7957Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.865 16.8193V17.2259L31.805 17.2288V16.921L31.6937 17.1853H31.6167L31.5053 16.921V17.2259H31.4311V16.8193H31.5225L31.6423 17.1098L31.7622 16.8193H31.865ZM31.2056 16.8891V17.226H31.1457V16.8891H31.0001V16.8194H31.3398V16.8891H31.2056Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.818bbac8cc253c2fdd1a5f18be6248ba.svg";
export { ForwardRef as ReactComponent };